/**
 * GraphQL's typename for campaign stats types
 */
const StatsTypeName = {
	prospectingCampaignStats: 'ProspectingCampaignStats',
	nurtureCampaignStats: 'NurtureCampaignStats',
} as const;

export { StatsTypeName };
